
import { Component, Vue } from 'vue-property-decorator'
import ActivateMessage from '@/components/templates/activate/ActivateMessage.vue'

/**
 * メールアドレス登録完了ページ
 */
@Component({
  components: {
    ActivateMessage,
  },
})
export default class RegistInformationComplete extends Vue {}
